import React from 'react';
import { Link } from 'react-router-dom';
import { buildPlannerHref } from '../utils/plannerLink';

/**
 * Renders SEO long-form sections for city/stadium guides + optional planner CTA.
 */
export function TravelLongformSections({ data }) {
  if (!data) return null;
  return (
    <div className="travel-longform max-w-none mt-8">
      {data.intro && (
        <p className="text-gray-700 dark:text-gray-300 leading-relaxed text-base mb-6 not-prose">
          {data.intro}
        </p>
      )}
      {data.sections?.map((sec) => (
        <section key={sec.id || sec.title} className="mb-10 not-prose">
          <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">{sec.title}</h2>
          {sec.paragraphs?.map((p, i) => (
            <p key={i} className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">
              {p}
            </p>
          ))}
          {sec.bullets && (
            <ul className="list-disc pl-6 space-y-2 text-gray-700 dark:text-gray-300">
              {sec.bullets.map((b) => (
                <li key={b}>{b}</li>
              ))}
            </ul>
          )}
        </section>
      ))}
      {data.plannerCta && (
        <div className="mt-10 p-6 rounded-xl bg-amber-50 dark:bg-amber-950/30 border border-amber-200/80 dark:border-amber-900/50 not-prose">
          <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">Plan this trip with AI</h3>
          <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">
            Open the itinerary planner with this city and duration pre-filled, then customize interests and match day.
          </p>
          <Link
            to={buildPlannerHref(data.plannerCta)}
            className="inline-flex items-center justify-center px-6 py-3 rounded-xl bg-amber-600 hover:bg-amber-700 text-white font-bold text-sm transition-colors"
          >
            Open AI itinerary planner
          </Link>
        </div>
      )}
    </div>
  );
}

export default TravelLongformSections;
